import { useEffect } from "react";
// my imports:
import UI from "@/app/lib/ui/ui";
import { GameManager } from "@/app/lib/game-state/game-manager";
import { isPath } from "@/app/lib/routing/path";
import { InternalRouter } from "@/app/lib/routing/internal-router";

export function useUrl(gameManager: GameManager, ui: UI) {
    // listen for back navigation
    useEffect(() => {
        const iRouter = new InternalRouter(gameManager, ui);

        function handlePopState(event: PopStateEvent) {
            const pathData = event.state?.path;
            let path = '/';
            if (isPath(pathData)) {
                path = pathData;
            } else if (isPath(window.location.pathname)) {
                path = window.location.pathname;
            }
            else {
                return;
            }
            if (isPath(path)) {
                iRouter.goPath(path, false);
            }
        }

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        }
    }, [])
}